import * as R from "ramda";
import { GenericSequenceType } from "../../../common/Constants";

export const constructDataDetailOtherItems = (data) => {
  console.log(data);
  
  return data
    .filter((item) => R.equals(item.saved, true))
    .map((item) => {
      return {
        otherCode: item.kodeotheritem ? item.kodeotheritem.value : null,
        total: Number(item.jumlah),
        idLocator: item.kodeLocation ? item.kodeLocation.value : null,
        barcode: item.qrotheritem ?? item.barcode,
        id: item.id
      };
    });
};

export const constructToQRReportItem = (data) => {
  return data
    .filter((item) => R.equals(item.saved, true))
    .map((item) => {
      return {
        itemName: item.namabaranglain,
        qrCode: item.qrCodeEncrypted,
        qrCodeRaw: item.qrcode,
      };
    });
};

export const validateDataDetailOtherItems = (list) => {
  
  const errors = [];
  const fieldsToValidate = ["kodeLocation", "kodeotheritem", "jumlah"];

  list.forEach((obj, index) => {
    const objErrors = {};

    fieldsToValidate.forEach((field) => {
      const value = obj[field];

      if (typeof value === "object" && value !== null) {
        if (!value.value || value.value === "") {
          objErrors[field] = `${field} cannot be empty or null`;
        }
      }
      else if (value === null || value === undefined || value === "") {
        objErrors[field] = `${field} cannot be empty or null`;
      }
    });

    const jumlah = Number(obj["jumlah"]);
    if (!R.isNil(jumlah)) {
      if (isNaN(jumlah) || jumlah < 1) {
        objErrors["jumlah"] = "jumlah must be greater than 0";
      }
    }

    if (Object.keys(objErrors).length > 0) {
      errors.push({ index, errors: objErrors });
    }
  });

  if (errors.length > 0) {
    console.error("Validation errors:", errors);
    return false;
  }

  return true;
};

export const getSupplierExpOptions = (data) => {
  return data.map((item) => {
    return {
      value: item.supplierCode,
      label: item.supplierCode,
      name: item.supplierName,
    };
  });
};

export const constructGenSeqPayload = (kodeCabang) => {
  return {
    seqType: GenericSequenceType.RECEIVING_ITEMS,
    nosDealerCode: kodeCabang.value,
    transactionType: GenericSequenceType.RECEIVING_ITEMS,
  };
};

export const getCompareOtherItemPayload = (data) => {
  return data?.map((item) => {
    const { kodeLocation, kodeotheritem, jumlah, barcode } = item;
    return { kodeLocation: kodeLocation?.value, kodeotheritem, jumlah, barcode };
  });
};

// export const checkIsListOtherItemChange = (origin, modified) => {
//   const originPayload = getCompareOtherItemPayload(origin);
//   const modifiedPayload = getCompareOtherItemPayload(modified);
//   console.log(originPayload);
//   console.log(modifiedPayload);
//   return JSON.stringify(originPayload) !== JSON.stringify(modifiedPayload);
// };
export const checkIsListOtherItemChange = (origin, modified) => {
  const originPayload = getCompareOtherItemPayload(origin) || [];
  const modifiedPayload = getCompareOtherItemPayload(modified) || [];
  
  if (!originPayload.length || !modifiedPayload.length) {
    return false;
  }

  const originMap = new Map(
    originPayload
      .filter(item => item.barcode === true)
      .map(item => [item.barcodeValue ?? item.barcode, item.jumlah])
  );

  for (const item of modifiedPayload) {
    if (item.barcode !== true) continue;

    const key = item.barcodeValue ?? item.barcode;
    const originJumlah = originMap.get(key);

    if (originJumlah !== undefined && originJumlah !== item.jumlah) {
      return true;
    }
  }

  return false;
};
